import _extend from 'lodash/extend';
import _round from 'lodash/round';
import moment from 'moment';

export default class Thing {
    constructor(data) {
        _extend(this, data);

        if (!this.labels) {
            this.labels = [];
        }
    }

    setTypeConfig(typeConfig) {
        this.typeConfig = typeConfig;
    }

    getTypeConfig() {
        return this.typeConfig;
    }

    static prepareBooleanValue(rawValue, format) {
        return rawValue ? format.trueValue : format.falseValue;
    }

    static prepareNumberValue(rawValue, format) {
        return format.replace('%s', _round(parseFloat(rawValue), 2));
    }

    static prepareTimestampValue(rawValue, format) {
        if (!rawValue) {
            return format.noValue;
        }
        const timestamp = moment(rawValue);
        if (timestamp.isAfter(moment().startOf('day'))) {
            return timestamp.format(format.freshValue);
        }
        return timestamp.format(format.oldValue);
    }

    static prepareStateValue(config, rawValue) {
        let value;

        if (config.type === 'boolean') {
            value = Thing.prepareBooleanValue(rawValue, config.format);
        } else if (config.type === 'number') {
            value = Thing.prepareNumberValue(rawValue, config.format);
        } else if (config.type === 'timestamp') {
            value = Thing.prepareTimestampValue(rawValue, config.format);
        }

        return value;
    }

    getHistoryChartType() {
        const typeConfig = this.getTypeConfig();
        if (typeConfig && typeConfig.state && typeConfig.state.history) {
            return typeConfig.state.history.chartType;
        }
        return null;
    }

    isHistoryAggregated() {
        const typeConfig = this.getTypeConfig();
        if (typeConfig && typeConfig.state && typeConfig.state.history) {
            return typeConfig.state.history.isAggregate;
        }
        return false;
    }

    getDefaultHistoryInterval() {
        const typeConfig = this.getTypeConfig();
        if (this.isHistoryAggregated()) {
            return typeConfig.state.history.defaultInterval;
        }
        return null;
    }

    getHistoryFieldsNavigatorConfig() {
        const typeConfig = this.getTypeConfig();
        if (typeConfig && typeConfig.state && typeConfig.state.history && typeConfig.state.history.navigator) {
            return typeConfig.state.history.navigator;
        }
        return this.getHistoryFieldsConfig();
    }

    getHistoryFieldsConfig() {
        const typeConfig = this.getTypeConfig();
        const fields = [];
        if (typeConfig && typeConfig.state && typeConfig.state.history) {
            if (this.isHistoryAggregated()) {
                Object.keys(typeConfig.state.history.functionMap).forEach((functionId) => {
                    fields.push({
                        name: typeConfig.state.history.key || typeConfig.state.key,
                        'function': typeConfig.state.history.functionMap[functionId]
                    });
                });
            } else {
                fields.push(typeConfig.state.history.key || typeConfig.state.key);
            }
        }
        return fields;
    }

    /**
     * Get Thing state value
     * @returns {null|string} Return null if state is absent or parsed state as string
     */
    getStateValue() {
        if (!this.state) return 'no state';

        const typeConfig = this.getTypeConfig();

        if (!typeConfig || !typeConfig.state) {
            return 'unknown type';
        }

        const rawValue = this.state.properties[typeConfig.state.key];

        return Thing.prepareStateValue(typeConfig.state.value, rawValue);
    }
}



// WEBPACK FOOTER //
// ./app/services/api/things/thing.class.js